import { render, staticRenderFns } from "./NFTDashboard.vue?vue&type=template&id=462bdc60&"
import script from "./NFTDashboard.vue?vue&type=script&lang=ts&"
export * from "./NFTDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports